import { Component, OnInit } from '@angular/core';
import { AppTranslationService } from '../app-translation.service';
import { VueServerMessage, VueServerMessageType } from '@vue/vueframework';

@Component({
  selector: 'app-not-found',
  standalone: false,
  styleUrls: [ './page-not-found.component.css' ],
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {
  public ACCOUNT_RECOVERY_BUNDLE_NAME = 'AccountRecovery';
  public messages: VueServerMessage[] = [];
  public translations = {
    pageNotFound: ''
  };

  public constructor(private appTranslationService: AppTranslationService) { }

  public ngOnInit(): void {
    this.messages.length = 0;
    this.getTranslations();
    this.messages.push(
      new VueServerMessage(VueServerMessageType.Error, this.translations.pageNotFound, false, '1')
    );
  }

  public getTranslations(): void {
    this.translations.pageNotFound = this.appTranslationService.getTranslation(this.ACCOUNT_RECOVERY_BUNDLE_NAME,
      'error.PageNotFound');
  }
}
